import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const FIELDS = [
  { name: "storeName", label: "Store name" },
  { name: "tagline", label: "Tagline" },
  { name: "whatsapp", label: "WhatsApp number (e.g. 2348087798684)" },
  { name: "phone", label: "Phone" },
  { name: "email", label: "Email" },
  { name: "instagram", label: "Instagram URL" },
  { name: "tiktok", label: "TikTok URL" },
  { name: "facebook", label: "Facebook URL" },
  { name: "location", label: "Location" },
  { name: "lowStockThreshold", label: "Low stock alert threshold", type: "number" },
];

export default function SettingsAdmin() {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setForm(r.data)).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { ...form };
      if (payload.lowStockThreshold !== undefined) payload.lowStockThreshold = Number(payload.lowStockThreshold);
      delete payload.id;
      delete payload.key;
      delete payload.paystackEnabled;
      await api.put("/admin/settings", payload);
      toast.success("Settings saved");
    } catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-settings">
      <h1 className="font-serif text-3xl text-espresso mb-1">Settings</h1>
      <p className="text-bark text-sm mb-8">Store details shown across your website.</p>

      <form onSubmit={save} className="max-w-xl space-y-4">
        {FIELDS.map((f) => (
          <div key={f.name}>
            <label className="text-sm text-bark mb-1.5 block">{f.label}</label>
            <Input
              type={f.type || "text"}
              value={form[f.name] ?? ""}
              onChange={(e) => setForm({ ...form, [f.name]: e.target.value })}
              data-testid={`settings-${f.name}`}
              className="border-sandline"
            />
          </div>
        ))}
        <Button type="submit" disabled={saving} data-testid="save-settings-button" className="bg-terracotta text-bone hover:bg-espresso">
          {saving ? "Saving…" : "Save settings"}
        </Button>
      </form>
    </div>
  );
}
